/**
 * 运行时商家配置 - 从 public/merchant-config.json 读取（构建时按域名生成）
 * 开发环境回退到 merchant.config.js
 */
let cached = null;
let promise = null;

export function getMerchantConfig() {
  if (cached) return Promise.resolve(cached);
  if (promise) return promise;

  if (process.env.NODE_ENV === 'development') {
    try {
      cached = require('../../merchant.config.js');
      return Promise.resolve(cached);
    } catch (e) {
      console.warn('merchant.config.js not found, using empty config');
      cached = { merchantName: '', merchantDomain: '', merchantMenuUrl: '/' };
      return Promise.resolve(cached);
    }
  }

  promise = fetch('/merchant-config.json')
    .then(res => {
      if (!res.ok) throw new Error('Merchant config not found');
      return res.json();
    })
    .then(config => {
      cached = config;
      return config;
    })
    .catch(() => {
      cached = { merchantName: '', merchantDomain: '', merchantMenuUrl: '/' };
      return cached;
    });

  return promise;
}
